import script from "./ClientListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientListView.vue?vue&type=script&setup=true&lang=js"

import "./ClientListView.vue?vue&type=style&index=0&id=043602c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043602c8"]])

export default __exports__